/* eslint-disable */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled, { withTheme } from 'styled-components'
import FlexBox from '../../components/common/FlexBox'
import Icon from '../../components/common/Icon'
import FontNumber from '../../components/common/FontNumber'
import Price from '../../components/exchange/Price'
import { floor, pencentage, formatNumber, calPrice } from '../../utils/number'
import { EXPLORER_URL } from '../../utils/httpRequest'
import { withI18n } from '../../i18n/util'

const ItemBox = styled.ul`
  display: flex;
  font-size: 13px;
  padding: 10px 0;
  li {
    margin-top: 5px;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    @media (max-width: 1340px) {
      padding: 0 4px;
    }
  }
  @media (min-width: 20px) and (max-width: 768px) {
    display: none;
  }
`

const MobileItemBox = styled.div`
  display: none;
  width: 100%;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  min-width: 300px;
  padding: 12px;
  position: relative;
  border-bottom: 8px solid #000;
  .trade-pair {
    font-size: 18px;
    position: relative;
    width: fit-content;
  }
  .more-trade-pair {
    position: absolute;
    right: -20px;
    top: 0;
  }
  .value {
    margin-left: 10px;
    text-align: left;
    white-space: nowrap;
  }
  .title {
    font-weight: 400;
    color: #848e9c;
  }
  @media (min-width: 20px) and (max-width: 768px) {
    display: block;
  }
`

const TradePair = styled.div`
  font-size: 20px;
  color: ${({ theme }) => theme.fontColor};
  white-space: nowrap;
  @media (max-width: 1400px) {
    white-space: normal;
  }
`

const Base = styled.span`
  font-size: 14px;
`

const Title = styled.div`
  color: #848e9c;
  font-size: 12px;
  white-space: nowrap;
  margin-top: 5px;
`

const Value = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.fontColor};
  white-space: nowrap;
`

const PriceUsd = styled.span`
  margin-left: 10px;
  font-size: 14px;
  color: ${({ theme }) => theme.fontColor};
  @media (min-width: 20px) and (max-width: 768px) {
    line-height: 30px;
    color: #848e9c;
  }
`

const Change = styled.div`
  color: ${props => props.color};
`

const SymbolName = styled.div`
  display: flex;
  align-content: center;
  font-size: 12px;
  line-height: 12px;
  cursor: pointer;
  .fullname {
    max-width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 12px;
    margin-left: 5px;
    color: #848e9c;
    &:hover {
      text-decoration: underline;
    }
  }
`

const Tag = styled.div`
  position: relative;
  top: -2px;
  background: rgb(240, 185, 11, 0.1);
  padding: 2px 4px;
  border-radius: 8px;
  font-size: 10px;
  line-height: 12px;
  color: #F0B90B;
  margin-left: 4px;
`

class SymbolPriceInfo extends PureComponent {
  static propTypes = {
    currentTrade: PropTypes.string,
    tickerSize: PropTypes.string,
    lotSize: PropTypes.string,
    dispatch: PropTypes.func,
    showTradePairList: PropTypes.func,
    trade: PropTypes.object,
    xBNBSymbol: PropTypes.object,
    cryptoCurrencyRate: PropTypes.object,
    lastPrice: PropTypes.number,
    highPrice: PropTypes.number,
    lowPrice: PropTypes.number,
    priceChangePercent: PropTypes.number,
    quoteVolume: PropTypes.string,
    formatI18nText: PropTypes.func,
    tokens: PropTypes.array,
  }

  static defaultProps = {
    currentTrade: '',
    trade: {},
    cryptoCurrencyRate: {},
    tokens: [],
    dispatch: () => {},
    xBNBSymbol: null,
    showTradePairList: () => {},
    tickerSize: '0.00000001',
    lotSize: '0.00000001',
    lastPrice: 0,
    highPrice: 0,
    lowPrice: 0,
    priceChangePercent: 0,
    quoteVolume: '',
    formatI18nText: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      type: 'rise',
    }
  }

  componentDidUpdate(nextProps) {
    const { trade } = this.props
    const newPrice = nextProps.trade.p ? parseFloat(nextProps.trade.p) : 0
    const oldPrice = trade.p ? parseFloat(trade.p) : 0
    if (newPrice === oldPrice) return
    if (newPrice > oldPrice) {
      // eslint-disable-next-line
      this.setState({ type: 'drop' })
    } else {
      // eslint-disable-next-line
      this.setState({ type: 'rise' })
    }
  }

  _calPrice = value => {
    const { tickerSize } = this.props
    let ts = 8
    if (tickerSize) {
      ts = Math.abs(Math.log10(tickerSize))
    }
    return floor(value, ts)
  }

  _getVolume = volume => {
    if (!volume) {
      return 0
    }
    return parseFloat(volume)
  }

  _usdPrice = (cryptoCurrencyRate, key, lastPrice) => {
    const { trade, xBNBSymbol } = this.props
    lastPrice = parseFloat(lastPrice, 10)
    if (cryptoCurrencyRate[key] && !trade.quoteAsset.includes('USDT')) {
      return `$${calPrice(lastPrice * cryptoCurrencyRate[key])}`
    }

    if (!xBNBSymbol) return ''

    return `$${calPrice(
      parseFloat(1 / xBNBSymbol.price, 10) * lastPrice * cryptoCurrencyRate.BNB_USDT
    )}`
  }

  _getPriceUsd = (symbol, cryptoCurrencyRate) => {
    if (symbol === 'USDT') return cryptoCurrencyRate.BNB_USDT
    return 0
  }

  _showTradePairs = () => {
    const { showTradePairList } = this.props
    showTradePairList && showTradePairList()
  }

  render() {
    const {
      currentTrade,
      cryptoCurrencyRate,
      tokens,
      tickerSize,
      trade,
      lastPrice,
      highPrice,
      lowPrice,
      priceChangePercent,
      quoteVolume,
      formatI18nText,
      theme,
    } = this.props
    const { type } = this.state
    const pair = currentTrade.split('_')
    const token = tokens.find(t => t.symbol === pair[0]) || {}
    const volume = this._getVolume(quoteVolume)
    const change = priceChangePercent || 0

    const quotaAsset = trade.quoteAsset && trade.quoteAsset.replace(/[\.-].+/, '')
    const key = Object.keys(cryptoCurrencyRate).find(c => c.includes(quotaAsset))
    const usdPrice = this._usdPrice(cryptoCurrencyRate, key, lastPrice)

    return (
      <FlexBox>
        <ItemBox>
          <li>
            <TradePair>
              {pair[0] && pair[0].replace(/[\.-].+/, '')}
              {' / '}
              <Base>{pair[1] && pair[1].replace(/[\.-].+/, '')}</Base>
            </TradePair>
            <SymbolName>
              <Icon type="network" size={12} color={theme.highlight} />
              <a
                target="_blank"
                title={token.name}
                href={`${EXPLORER_URL}/asset/${pair[0]}`}
                className="fullname"
              >
                {token.name}
              </a>
              {token.token_type && <Tag>MiniToken</Tag>}
            </SymbolName>
          </li>
          <li>
            <Title>{formatI18nText('exchange.symbolPriceInfo.lastPrice')}</Title>
            <FlexBox>
              <Price
                value={lastPrice}
                tickerSize={tickerSize}
                priceColor={type === 'rise' ? theme.up : theme.down}
              />
              <PriceUsd>
                <FontNumber value={usdPrice} />
              </PriceUsd>
            </FlexBox>
          </li>
          <li>
            <Title>{formatI18nText('exchange.symbolPriceInfo.twentyFourHChange')}</Title>
            <Change color={parseFloat(change) >= 0 ? theme.up : theme.down}>
              <FontNumber
                value={
                  parseFloat(change) >= 0
                    ? `+${pencentage(change, 1)}`
                    : `-${pencentage(change, 1)}`
                }
              />
            </Change>
          </li>
          <li>
            <Title>{formatI18nText('exchange.symbolPriceInfo.twentyFourHHigh')}</Title>
            <Value>
              <FontNumber value={highPrice && this._calPrice(highPrice)} />
            </Value>
          </li>
          <li>
            <Title>{formatI18nText('exchange.symbolPriceInfo.twentyFourHLow')}</Title>
            <Value>
              <FontNumber value={lowPrice && this._calPrice(lowPrice)} />
            </Value>
          </li>
          <li>
            <Title>{formatI18nText('exchange.symbolPriceInfo.twentyFourHVolume')}</Title>
            <Value>
              <FontNumber value={formatNumber(volume, 2)} />
              {` ${pair[1] || ''}`}
            </Value>
          </li>
        </ItemBox>
        <MobileItemBox>
          <FlexBox justify="space-between">
            <FlexBox>
              <Price
                value={lastPrice}
                fontSize="20px"
                priceColor={type === 'rise' ? theme.up : theme.down}
              />
              <PriceUsd>
                <FontNumber value={usdPrice} />
              </PriceUsd>
            </FlexBox>
            <FlexBox content="center">
              <div className="title">{formatI18nText('exchange.symbolPriceInfo.high')}</div>
              <div className="value">
                <FontNumber value={highPrice && this._calPrice(highPrice)} />
              </div>
            </FlexBox>
          </FlexBox>
          <FlexBox justify="space-between">
            <FlexBox>
              <span style={{ marginRight: '10px' }}>
                <Change color={parseFloat(change) > 0 ? theme.up : theme.down}>
                  <FontNumber
                    value={
                      parseFloat(change) >= 0
                        ? `+${pencentage(change, 1)}`
                        : `-${pencentage(change, 1)}`
                    }
                  />
                </Change>
              </span>
              <div className="title">{formatI18nText('exchange.symbolPriceInfo.vol')}</div>
              <div className="value">
                <FontNumber value={formatNumber(volume, 2)} />
              </div>
            </FlexBox>
            <FlexBox content="center">
              <div className="title">{formatI18nText('exchange.symbolPriceInfo.low')}</div>
              <div className="value">
                <FontNumber value={lowPrice && this._calPrice(lowPrice)} />
              </div>
            </FlexBox>
          </FlexBox>
        </MobileItemBox>
      </FlexBox>
    )
  }
}

const mapStateToProps = ({
  exchange: { userInfo, displayCurrentTrade, currentTrade, cryptoCurrencyRate, tokens },
  tickers: { symbolTickers, tickerSize, lotSize },
  trade: { tradeHistory },
}) => {
  const trade = (tradeHistory && tradeHistory.trade[0]) || {}
  const currentTicker = symbolTickers.find(t => t.symbol && t.symbol.includes(currentTrade)) || {}
  const { price, highPrice, lowPrice, priceChangePercent, quoteVolume } = currentTicker
  return {
    userInfo,
    currentTrade: displayCurrentTrade,
    trade,
    cryptoCurrencyRate,
    lastPrice: parseFloat(trade.price || price),
    highPrice: Number(highPrice),
    lowPrice: Number(lowPrice),
    priceChangePercent,
    quoteVolume,
    tokens,
    xBNBSymbol: symbolTickers.find(st => st.symbol === `BNB_${trade.quoteAsset}`),
    tickerSize: tickerSize[currentTrade],
    lotSize: lotSize[currentTrade],
  }
}

export default withI18n(connect(mapStateToProps)(withTheme(SymbolPriceInfo)))
